import { BookingSourceEnum } from 'app/models/enums/booking-source.enum';

export class BookingSourceModel {
	public static readonly List: Array<{ value: BookingSourceEnum; name: string }> = [
		{ value: BookingSourceEnum.App, name: 'App' },
		{ value: BookingSourceEnum.X4b, name: 'X4B' },
		{ value: BookingSourceEnum.WalkIn, name: 'Walk-in' }
	];
}
